import { isMobile } from 'react-device-detect';

import { Drawer, DrawerContent, Switch, Button } from '@pella/sash-framework';

import * as classes from './SetupDrawer.module.css';

/**
 * Component for the Setup Drawer.
 * @param {Local.DrawerProps} props - Component props
 */
export const SetupDrawer = ({
  open,
  close,
  title,
  isEdit,
  isCopy,
  active,
  onActiveChange,
  onSubmit,
  disableSubmit,
  children,
}) => {
  const handleTitles = () => {
    if (isCopy) {
      return `Copy ${title}`;
    }
    if (isEdit) {
      return `Modify ${title}`;
    }
    return `New ${title}`;
  };

  const handleButtonText = () => {
    if (isCopy) {
      return `COPY ${title.toUpperCase()}`;
    }
    if (isEdit) {
      return `UPDATE ${title.toUpperCase()}`;
    }
    return `CREATE ${title.toUpperCase()}`;
  };

  const lowerCaseTitle = title.toLowerCase();

  return (
    <Drawer direction={isMobile ? 'bottom' : 'right'} open={open} onOpenChange={close}>
      <DrawerContent className={classes.drawer} titleText={handleTitles()} showClose={false}>
        <div className={classes.content}>
          {lowerCaseTitle !== 'selection list' && (
            <div className={classes.status}>
              <div>
                <b>Status</b>
                <div>Enable or disable the {lowerCaseTitle}</div>
              </div>
              <div>
                <Switch data-testid={`${lowerCaseTitle}StatusSwitch`} checked={active} onChange={onActiveChange} />
              </div>
            </div>
          )}
          {children}
          <div className={classes.drawerFooter}>
            <Button data-testid={`cancel${title}`} className={classes.button} color='secondary' onClick={close}>
              CANCEL
            </Button>
            <Button
              data-testid={`submit${title}`}
              className={classes.button}
              color='primary'
              onClick={onSubmit}
              disabled={disableSubmit}
            >
              {handleButtonText()}
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
